module.exports = __webpack_public_path__ + "img/messLing.a7f30e66.svg";